import {
  Box,
  Grid,
  HeadingNumber,
  Typography,
  TypographyProps,
} from '@oresundsbron/bridge-ui';
import { cx } from 'class-variance-authority';
import { FC, PropsWithChildren } from 'react';
import { EditButton } from './Buttons';

export const FieldSet: FC<
  PropsWithChildren<{
    nr?: number;
    title: string;
    id: string;
    editButton?: boolean;
    full?: boolean;
    className?: string;
    titleIntent?: TypographyProps['intent'];
    titleSize?: TypographyProps['size'];
  }>
> = ({
  nr,
  title,
  children,
  id,
  editButton = true,
  full = true,
  className,
  titleIntent = 'headline',
  titleSize = 'sm',
}) => (
  <Box
    as="fieldset"
    className={cx(full ? 'min-h-screen' : undefined, 'pb-8', className)}
  >
    <Box className="mb-4 flex flex-row items-center">
      {nr ? <HeadingNumber className="mr-4">{nr}</HeadingNumber> : null}
      <Typography
        as="legend"
        intent={titleIntent}
        size={titleSize}
        id={id}
        className="scroll-mt-[10vh]"
      >
        {title}
      </Typography>
      {editButton ? <EditButton namespace={id} /> : null}
    </Box>
    <Grid className="gap-4">{children}</Grid>
  </Box>
);
